import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight, Building2, Clock3, House, MessageCircle, UserRound, Users } from "lucide-react";
import { API } from "@/components/listings/common";

const TPL = { approved: ["Aktif — onay/ret mesajları üyelere gidiyor", "ok"], received: ["Meta onayı bekleniyor", "wait"], pending: ["Meta onayı bekleniyor", "wait"], rejected: ["Meta şablonu reddetti", "bad"],
  paused: ["Şablon Meta tarafından durduruldu", "bad"], missing: ["Şablon kodu girilmemiş (Ayarlar → Twilio)", "bad"], unknown: ["Durum alınamadı", "wait"] };

function NotifyStatus() {
  const [s, setS] = useState(null);
  useEffect(() => { axios.get(`${API}/platform/notify-status`).then((r) => setS(r.data)).catch(() => setS({ status: "unknown" })); }, []);
  const [t, cls] = TPL[s?.status] || TPL.unknown;
  return (
    <div className={`panel notify-status ${s ? cls : "wait"}`} data-testid="platform-notify-status">
      <MessageCircle size={20} /><span><b>WhatsApp ilan bildirimleri</b><small data-testid="platform-notify-status-text">{s ? t : "Kontrol ediliyor…"}{s?.rejection_reason ? ` · ${s.rejection_reason}` : ""}</small></span>
    </div>
  );
}

function Metric({ label, value, sub, icon: Icon, testid }) {
  return <div className="metric" data-testid={testid}><div className="metric-top"><span>{label}</span><Icon size={18} /></div><strong>{value ?? "–"}</strong><small>{sub}</small></div>;
}

export default function PlatformOverview({ sum, go }) {
  const m = sum?.members, l = sum?.listings;
  return (
    <>
      <div className="page-title"><div><span className="eyebrow">EMLAKSEPETI.ONLINE</span><h1 data-testid="page-title">Emlak Sepeti paneli</h1><p>Üyeleriniz ve üyelerin verdiği ilanlar.</p></div></div>
      <div className="metric-grid">
        <Metric label="Onay bekleyen ilan" value={l?.pending} sub="İncelemenizi bekliyor" icon={Clock3} testid="platform-metric-pending" />
        <Metric label="Yayındaki üye ilanı" value={l?.active} sub={`Ofis ilanı: ${sum?.office_active ?? 0}`} icon={House} testid="platform-metric-active" />
        <Metric label="Toplam üye" value={m?.total} sub={m ? `${m.blocked} askıda` : ""} icon={Users} testid="platform-metric-members" />
        <Metric label="Bireysel / Kurumsal" value={m ? `${m.bireysel} / ${m.kurumsal}` : null} sub="Üyelik tipi" icon={m?.kurumsal > m?.bireysel ? Building2 : UserRound} testid="platform-metric-types" />
      </div>
      <div className="platform-actions">
        <button className="panel platform-link" onClick={() => go("ilanlar")} data-testid="platform-go-listings"><Clock3 size={20} /><span><b>Üye ilanlarını incele</b><small>{l?.pending ? `${l.pending} ilan onay bekliyor` : "Bekleyen ilan yok"}</small></span><ArrowUpRight size={16} /></button>
        <button className="panel platform-link" onClick={() => go("uyeler")} data-testid="platform-go-members"><Users size={20} /><span><b>Üyeler</b><small>Bireysel ve kurumsal hesaplar</small></span><ArrowUpRight size={16} /></button>
        <button className="panel platform-link" onClick={() => go("ayarlar")} data-testid="platform-go-settings"><House size={20} /><span><b>Site ayarları</b><small>İletişim, ana sayfa, hakkımızda</small></span><ArrowUpRight size={16} /></button>
      </div>
      <NotifyStatus />
    </>
  );
}
